module.exports = __webpack_public_path__ + "img/40_57.ec75273d.png";